const organizationsState = {
    organization: undefined,
    organizations: [],
    requestingOrganizations: false
};
export default organizationsState;
